import { render, staticRenderFns } from "./TkLogo.vue?vue&type=template&id=4622839a&scoped=true&"
import script from "./TkLogo.vue?vue&type=script&lang=ts&"
export * from "./TkLogo.vue?vue&type=script&lang=ts&"
import style0 from "./TkLogo.vue?vue&type=style&index=0&id=4622839a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622839a",
  null
  
)

export default component.exports